import { Component, ElementRef, Injector, ViewChild, AfterContentInit, AfterViewInit } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as jQuery from "jquery";
import { IChartTechnicalIndicatorInfo } from "../../achart/achart.technicalIndicators";
import { initRequest, DataService } from "../../../services/data/data.service";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { BoxQuotaData} from "../../../model/box.quote.data";
import { validateConfig } from "@angular/router/src/config";
import { IQuotaData, getPipBySymbol, numberToFixedPrecision } from "../../../interfaces/quote.data";
import { TradeRequestModel, EditRq, PartialCloseRq } from "../../../model/trade.request.data";
import { CookiesService } from "../../../tools/cookies.service";
import { IOrdersData } from "../../../interfaces/service.response";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { SymbolTypeEnum } from "../../../enums/SymbolType.enum";
import { map } from "rxjs/operators";
import { ShowOrderConfirmationModal } from "../orderconfirmation/show-order-confirmation-modal";
import { Account } from '../../../api/DixApiClient';
import {Providers} from "../../../enums/providers";
import {OrderEntryModal, OrderEntryType, OrderOperationType} from "./orderentry.component";


@Component({
    selector: "modal-orderentry",
    template: require('./new-layout/orderentry-new-layout.component.html'),
    styles: [require('./new-layout/orderentry-new-layout.component.css')]
})
export class OrderEntryContent extends OrderEntryModal implements  AfterViewInit {

  
    constructor(
        public activeModal: NgbActiveModal,
        protected element: ElementRef,
        protected dataService: DataService,
        protected modalService: NgbModal,
        protected cookieService: CookiesService,
        protected workspaceService: WorkspaceServiceService,
        protected workspaceServiceService: WorkspaceServiceService
    ) {
        super(
            activeModal,
            element,
            dataService,
            modalService,
            cookieService,
            workspaceService,
            workspaceServiceService
        );
     
        this.accountNameObj = this.workspaceService.data.getFullAccountNameByIdObj(this.selectedTradingAccountId)
        
       
    }

    ///fix for binding problem
    public typesMap:string[] = ["Market","Pending"];
    public sidesMap:string[] = ["Sell","Buy"];

    private _typesStrMap = "Market";
    public get typesStrMap() {
        return (this.type==OrderEntryType.Market)?"Market":"Pending";
    }


        public set typesStrMap(value) {
        this._typesStrMap = value;

        if(value=="Market")
        {
            this.type = OrderEntryType.Market
        }

        if(value=="Pending")
        {
            this.type = OrderEntryType.Pending
        }
    }

    private _sidesStrMap = "Sell";
    public get sidesStrMap() {
        return (this.operationType==OrderOperationType.Buy)?"Buy":"Sell";
    }

    public set sidesStrMap(value) {
        this._sidesStrMap = value;

        if(value=="Buy")
        {
            this.operationType = OrderOperationType.Buy
        }

        if(value=="Sell")
        {
            this.operationType = OrderOperationType.Sell
        }
    }
    
    public accountNameObj?:{name?:string | null | undefined,short?:string | null | undefined};
    // public get accountNameObj()
    // {
    //     return this.workgetFullAccountNameByIdObj
    // }

}
